<template>
  <job-left-menu>
    <div class="job-left-menu__content">
      <section-separator class="group-separator" v-if="$can('admin-jobs-all')">
        {{$t('job.menu.title')}}
      </section-separator>

      <saved-filters :entity="entity"></saved-filters>

      <section-separator class="group-separator" v-if="$can('admin-jobs-all')">
        {{$t('job.menu.client_type')}}
      </section-separator>
      <a v-for="option in clientTypeOptions"
         :key="option.value"
         class="nav-list__item cursor-pointer"
         :class="{ active: clientType === option.value }"
         @click="setClientType(option.value)">
        {{option.label}}
      </a>

      <section-separator class="group-separator" v-if="$can('admin-jobs-all')">
        {{$t('organization.menu.title')}}
      </section-separator>
      <router-link :to="{name: organizationRoute}" class="nav-list__item" v-if="$can('admin-jobboard-all')">
        {{$t('generic.all')}}
      </router-link>
    </div>
  </job-left-menu>
</template>
<script>
  import JobLeftMenu from './JobLeftMenu'
  import SavedFilters from 'src/components/Filters/SavedFilters'
  import { getRouteName, routeTypes } from 'src/config/routeTypes'
  import entities from 'src/config/entities'

  export default {
    name: 'job-filters',
    components: {
      JobLeftMenu,
      SavedFilters
    },
    data () {
      return {
        entity: entities.JOB,
        organizationRoute: getRouteName(routeTypes.LIST, entities.ORGANIZATION),
        jobsRoute: getRouteName('jobs-filter', entities.JOB),
        jobReportsRoute: getRouteName(routeTypes.LIST, entities.JOB_REPORTS),
        jobAlertsRoute: getRouteName(routeTypes.LIST, entities.JOB_ALERT),
        clientType: '',
      }
    },
    computed: {
      clientTypeOptions () {
        return [
          { value: '', label: this.$t('job.menu.all') },
          { value: 'organisation', label: this.$t('job.menu.client_type_organisation') },
          { value: 'intermediary', label: this.$t('job.menu.client_type_intermediary') },
          { value: 'reseller', label: this.$t('job.menu.client_type_reseller') },
          { value: 'other', label: this.$t('job.menu.client_type_other') },
        ]
      }
    },
    methods: {
      // EX-143: the client-type choices behave like the status presets above — they
      // replace the active filters and route to the jobs list, which refetches.
      setClientType (value) {
        this.clientType = value
        this.$store.commit('filters/SET_ACTIVE_FILTERS', value ? [this.clientTypeFilter(value)] : [])
        this.$router.push({
          name: getRouteName(routeTypes.LIST, this.entity),
          query: value ? { client_type: value } : {}
        }).catch(() => {})
      },
      clientTypeFilter (value) {
        const options = {
          organisation: this.$t('job.menu.client_type_organisation'),
          intermediary: this.$t('job.menu.client_type_intermediary'),
          reseller: this.$t('job.menu.client_type_reseller'),
          other: this.$t('job.menu.client_type_other'),
        }
        return {
          field: {
            field: 'client_type',
            label: this.$t('job.menu.client_type'),
            type: 'multiselect',
            typeahead: null,
            options,
          },
          operator: 'IS',
          values: value,
          label: this.$t('job.menu.client_type'),
          selected: true,
          valuesLabel: options[value],
        }
      }
    }
  }
</script>
<style scoped>
  .job-left-menu__content .group-separator:first-child {
    margin-top: 0;
  }
</style>
